import HomePageSwipper from "../../components/swiper/homepageswipper/homepageswipper";
import FeatureHighlights from "../../components/featurehighlights/FeatureHighlights";
import HomeCategorySwipper from "../../components/swiper/homecategoryswipper/homecategoryswipper";
import HomeClient from "../../components/homeclient/HomeClient";
import "./home.css";

const HomePage = () => {
  return (
    <div className="homepage">
      <HomePageSwipper />
      <FeatureHighlights />
      <HomeCategorySwipper />
      <HomeClient />
    </div>
  );
};

export default HomePage;
